// extracted by mini-css-extract-plugin
module.exports = {"languageContainer":"language_languageContainer__2bn-2","language":"language_language__bOUp4","flag":"language_flag__2NaT5","hiddenInMobile":"language_hiddenInMobile__1-Tfp"};